import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchGrupoPlanes } from '../../actions/planesActions';
import { setTiposGrupoPlanes, resetValueChecked, setTiposPublicacion } from '../../actions/tiposPublicacionActions';
import SafeReactPaginate from '../General/SafeReactPaginate';
import GoBackArrow from '../General/GoBackArrow';
import { withNavigation } from '../General/withNavigation';
import { resolveGrupoPlanId } from '../../helper/tipoPublicacionHelper';

const FILTER_DEBOUNCE_MS = 320;

// Wrapper para usar hooks en class component
function BusquedaGrupoPlanesWrapper(props) {
    const navigate = useNavigate();
    return <BusquedaGrupoPlanes {...props} navigate={navigate} />;
}


class BusquedaGrupoPlanes extends Component {
    constructor(props) {
        super(props);
        const selected = Array.isArray(this.props.tiposGruposPlanes) ? [...this.props.tiposGruposPlanes] : [];

        this.state = {
            Descripcion: "",
            page: 1,
            CantidadTotal: 0,
            estadoGrupoPlanes: selected
        };
        this._filterDebounce = null;
    }

    componentWillUnmount() {
        if (this._filterDebounce) {
            clearTimeout(this._filterDebounce);
        }
    }


    componentDidMount() {
        this.setState({ page: 1 }, () => this.executeRequest());
    }

    isChecked = (item) => {
        const id = resolveGrupoPlanId(item);
        return id != null && this.state.estadoGrupoPlanes.some(x => resolveGrupoPlanId(x) === id);
    }

    changeCheck = (item) => {
        const id = resolveGrupoPlanId(item);
        if (id == null) return;
        let arrayGrupo = [...this.state.estadoGrupoPlanes];
        const exists = arrayGrupo.some(x => resolveGrupoPlanId(x) === id);

        if (exists) {
            arrayGrupo = arrayGrupo.filter(x => resolveGrupoPlanId(x) !== id);
        } else {
            arrayGrupo.push(item);
        }

        this.setState({ estadoGrupoPlanes: arrayGrupo });
    }

    agregarGrupoPlanes = (e) => {
        e.preventDefault();
        this.props.setTiposGrupoPlanes(this.state.estadoGrupoPlanes);
        const { editando, tiposPublicacion } = this.props;
        if (editando) {
            this.props.navigate(`/Tipo/Publicaciones/Editar/${tiposPublicacion}`);
        } else {
            this.props.navigate(`/Tipo/Publicaciones/Nuevo`);
        }
    }


    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.setState({ page: selectedPage }, () => {
            this.executeRequest();
        });
    };

    myChangeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value, page: 1 }, () => {
            if (this._filterDebounce) clearTimeout(this._filterDebounce);
            this._filterDebounce = setTimeout(() => {
                this._filterDebounce = null;
                this.executeRequest();
            }, FILTER_DEBOUNCE_MS);
        });
    }

    executeRequest = () => {
        const request = { params: { page: this.state.page, pageSize: 10, Descripcion: this.state.Descripcion } };
        this.props.fetchGrupoPlanes(request);
    }

    goBack = (e) => {
        e.preventDefault()
        window.history.go(-1)
    }

    render() {
        const { grupoPlanes, paginacion } = this.props;
        const totalItems = paginacion ? (paginacion.cantidadTotal || paginacion.total || 0) : 0;
        const itemsPerPage = paginacion ? (paginacion.cantidadPagina || paginacion.pageSize || 10) : 10;
        const pageCountVal = paginacion ? (paginacion.cantidadPaginas || paginacion.totalPages || Math.max(1, Math.ceil(totalItems / Math.max(itemsPerPage, 1)))) : 0;

        return (
            <div className="container py-2">
                <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                    <div className="admin-grupo-busqueda-header">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <GoBackArrow />
                            <div>
                                <h4 className="mb-0 text-body fw-semibold">Grupos de planes</h4>
                                <p className="small text-body-secondary mb-0 mt-1">Seleccioná uno o más grupos para asociar al tipo de publicación.</p>
                            </div>
                        </div>
                    </div>

                    <div className="admin-grupo-busqueda-toolbar">
                        <div className="row g-2 align-items-end">
                            <div className="col-12 col-md-5 col-lg-4">
                                <label className="form-label small text-body-secondary mb-1">Descripción</label>
                                <input
                                    onChange={this.myChangeHandler}
                                    className="form-control"
                                    name="Descripcion"
                                    type="text"
                                    placeholder="Buscar por descripción…"
                                    value={this.state.Descripcion}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="admin-grupo-busqueda-body">
                        <div className="admin-list-stack">
                            {grupoPlanes &&
                                grupoPlanes.map((item, index) => {
                                    const selected = this.isChecked(item);
                                    const isActivo = item.estado === 0;
                                    const cardEstado = isActivo ? 'admin-list-card--vigente' : 'admin-list-card--inactivo';
                                    return (
                                        <div
                                            key={item.idGrupoPlan ?? index}
                                            className={`admin-list-card p-3 ${cardEstado} ${selected ? 'admin-list-card--selected' : ''}`}
                                        >
                                            <div className="row g-2 g-md-3 align-items-center justify-content-between">
                                                <div className="col-auto">
                                                    <span className="admin-id-badge">{item.idGrupoPlan}</span>
                                                </div>
                                                <div className="col-12 col-md-5 col-lg-6 text-break">
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={item.descripcion ?? ""}
                                                        className="form-control-plaintext admin-list-card__title fw-semibold small mb-0 py-0"
                                                        title="Seleccioná el texto para copiar"
                                                        style={{ cursor: 'text' }}
                                                        aria-label="Nombre del plan"
                                                    />
                                                </div>
                                                <div className="col-6 col-md-auto d-flex justify-content-md-end">
                                                    <span className="admin-metric-pill">
                                                        {item.comision}
                                                        <i className="fas fa-percent" aria-hidden="true" />
                                                    </span>
                                                </div>
                                                <div className="col-6 col-md-auto d-flex justify-content-end align-items-center" onClick={(e) => e.stopPropagation()}>
                                                    <div className="form-check form-switch mb-0">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={"switch" + item.idGrupoPlan}
                                                            checked={selected}
                                                            onChange={() => this.changeCheck(item)}
                                                            style={{ cursor: 'pointer' }}
                                                            aria-label={`Seleccionar grupo ${item.idGrupoPlan}`}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>

                        <div className="d-flex justify-content-center mt-3">
                            {paginacion && totalItems > 0 && (
                                <SafeReactPaginate
                                    previousLabel={"Anterior"}
                                    nextLabel={"Siguiente"}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={pageCountVal}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={this.state.page - 1}
                                />
                            )}
                        </div>

                        <div className="row align-items-center justify-content-center gap-2 mt-4 pt-3 border-top">
                            <div className="col-auto">
                                <button
                                    type="button"
                                    onClick={this.agregarGrupoPlanes}
                                    className="btn btn-sm btn-green px-4"
                                >
                                    Seleccionar
                                </button>
                            </div>
                            <div className="col-auto">
                                <button type="button" onClick={(e) => this.goBack(e)} className="btn btn-sm background-rojo-megatone">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    seller: state.general.idSeller,
    editando: state.general.editando,
    paginacion: state.planes.grupoPlanes,
    grupoPlanes: state.planes.grupoPlanes.elementos,
    tiposGruposPlanes: state.tiposPublicacion.tiposGruposPlanes,
    tiposPublicacion: state.tiposPublicacion.tiposPublicacion.codigo
});


export default withNavigation(connect(mapStateToProps, {
    fetchGrupoPlanes,
    setTiposGrupoPlanes,
    resetValueChecked,
    setTiposPublicacion,
})(BusquedaGrupoPlanesWrapper));
